<template>
    <div>
        <div class="row">
            <div class="col-md-12 ">
                <div class="panel panel-default">
                    <div class="panel-heading">Error Report</div>

                    <div class="panel-body">

                        <CrawlTimeSeries
                                :height="chart_height"
                                :width="chart_width"
                                :distribution="distribution"
                                :processedData="processed_timeseries"
                        />

                    </div>
                </div>
                <div class="panel panel-default">
                    <div class="panel-heading">First Errors</div>

                    <div class="panel-body">
                        <el-table
                                :data="raw_timeseries.examples"
                                stripe
                                style="width: 100%"
                        >
                            <el-table-column
                                prop="exception_text"
                                label="Exception Text"
                                ></el-table-column>
                            <el-table-column
                                    prop="created_at"
                                    label="Timestamp"
                            ></el-table-column>
                            <el-table-column
                                    prop="address_or_filename"
                                    label="URL"
                            ></el-table-column>
                            <el-table-column
                                    prop="response_type"
                                    label="Response Type"
                            ></el-table-column>
                            <el-table-column
                                    prop="response_code"
                                    label="Response Code"
                            ></el-table-column>
                            <el-table-column
                                    prop="found_on"
                                    label="Found On"
                            ></el-table-column>

                        </el-table>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    // Also see app.scss!!! That's where some of the transition stuff is stored
    import AfterDataImport from './AfterDataImport.vue'
    import CrawlTimeSeries from "../DataExploration/CrawlTimeSeries";
    import * as screenfull from 'screenfull';
    export default {
        filters: {
            commas: function(value) {
                if (value) {
                    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                } else {
                    return value
                }
            }
        },
        components: {CrawlTimeSeries},
        props: ['job_chain_step_id'],
        mounted() {
            axios.get("/progress/error_timeseries/" + this.job_chain_step_id)
                .then(response => {
                    this.raw_timeseries = response.data
                    console.log("got raw timeseries")
                    console.log(this.raw_timeseries)
                    this.setTimeSeriesData()
                })
                .catch(error => {
                    console.log("Cannot get error timerseries")
                    console.log(error)
                })
            if (chimera.permissions.includes('BLEEDING_EDGE')) this.show_bleeding_edge = true
        },
        computed: {
            chart_height: function() {
                if (!this.is_full_screen) return 250
                else {
                    return screen.height - 30
                }
            },
            chart_width: function() {
                if (!this.is_full_screen) return 1108
                else {
                    return screen.width - 30
                }
            },
        },
        data() {
            return {
                processed_timeseries: '',
                max_timestamp: null,
                distribution: 'linear',
                is_full_screen: false,
                show_bleeding_edge: false,
                raw_timeseries: null,
            }
        },
        methods: {
            setColor(index,total_count) {
                let level = index * (255/total_count)
                let stroke_level = level
                if (level<=205) {
                    stroke_level = stroke_level + 50
                }
                let color = {
                    fill: `rgba(${level},${level},${level},0.5)`,
                    stroke: `rgba(${stroke_level},${stroke_level},${stroke_level},0.5)`,
                }
                return color
            },
            setTimeSeriesData() {

                console.log("raw timeseries at start of setTimeSeriesData()")
                console.log(this.raw_timeseries)

                let labels = this.raw_timeseries.labels

                let index = 0
                let label_count = labels.length

                let datasets = []

                labels.forEach((element) =>  {
                    let color = this.setColor(index,label_count)
                    let dataset = {
                        label: element,
                        fill: true,
                        backgroundColor: color.fill,
                        pointBackgroundColor: color.fill,
                        borderColor: color.stroke,
                        pointHighlightStroke: color.stroke,
                        data: this.raw_timeseries.datasets[index],
                    }

                    datasets.push(dataset)
                    index++
                });

                console.log('just the datasets portion after processing in setTimeSeriesData()')
                console.log(datasets)

                this.processed_timeseries = {
                    labels: this.raw_timeseries.timestamps,
                    datasets: datasets
                }
                console.log('the whole processed timeseries in setTimeSeriesData()')
                console.log(this.processed_timeseries)
                // console.log("done setting processed_timeseries")
                // console.log(this.processed_timeseries)
            },
        }
    }
</script>